import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import type { AttributionMix } from "@/hooks/use-attribution-note";
import { cn } from "@/lib/utils";

export interface AttributionNoteProps {
  /** Non-null mix from `useAttributionMix`; sellers-only scopes render nothing upstream. */
  mix: NonNullable<AttributionMix>;
  className?: string;
}

/**
 * Flags 1P (14-day) Sponsored Products attribution in a scope, with the full
 * explanation in a tooltip (#671). The caller decides where it sits (a panel
 * subtitle, a filter-bar chip) and styles the trigger via `className`.
 */
export function AttributionNote({ mix, className }: AttributionNoteProps): React.ReactElement {
  const { t } = useTranslation("campaign");
  return (
    <Tooltip>
      <TooltipTrigger
        data-slot="attribution-note"
        className={cn(
          "rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-ring",
          className,
        )}
        render={<button type="button" />}
      >
        {t(`performance.attribution.${mix}`)}
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        {t(`performance.attribution.${mix}Hint`)}
      </TooltipContent>
    </Tooltip>
  );
}
